<template>
  <div class="wf-node wf-external" :class="`wf-external--${data.kind}`">
    <Handle id="in" type="target" :position="Position.Left" />
    <div class="wf-external__icon">
      <Icon :name="data.icon" class="w-4 h-4" />
    </div>
    <div class="wf-external__label" :title="data.label">{{ data.label }}</div>
  </div>
</template>

<script>
import { Handle, Position } from '@vue-flow/core';
import Icon from '@/ui-components/Icon.vue';

export default {
  name: 'ExternalNode',
  components: { Handle, Icon },
  props: {
    data: { type: Object, default: () => ({}) },
  },
  data() {
    return { Position };
  },
};
</script>
